// extracted by mini-css-extract-plugin
module.exports = {"solutionsWrapper":"SearchSolutions_solutionsWrapper__gtl1f","solutions":"SearchSolutions_solutions__0hUIP"};